import { render, staticRenderFns } from "./facebookCatalog.vue?vue&type=template&id=e13b942e&scoped=true&"
import script from "./facebookCatalog.vue?vue&type=script&lang=js&"
export * from "./facebookCatalog.vue?vue&type=script&lang=js&"
import style0 from "./facebookCatalog.vue?vue&type=style&index=0&id=e13b942e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13b942e",
  null
  
)

export default component.exports